// src/pages/WatchRedirect.jsx
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.shashatana.ye';
const APP_SCHEME = 'shashatana';
const ANDROID_PACKAGE = 'com.shashatana.ye';

export default function WatchRedirect() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.replace(/^\/+/, '');
    const search = location.search || '';

    const ua = navigator.userAgent || navigator.vendor || '';
    const isAndroid = /android/i.test(ua);
    const isIOS = /iphone|ipad|ipod/i.test(ua);

    if (isAndroid) {
      // Native Android intent — auto-falls back to Play Store if app missing.
      const intentUrl =
        `intent://${path}${search}` +
        `#Intent;scheme=${APP_SCHEME};` +
        `package=${ANDROID_PACKAGE};` +
        `S.browser_fallback_url=${encodeURIComponent(PLAY_STORE_URL)};end`;
      window.location.href = intentUrl;
      return;
    }

    if (isIOS) {
      // iOS: try scheme, fall back to store after delay.
      const appUrl = `${APP_SCHEME}://${path}${search}`;
      const start = Date.now();
      window.location.href = appUrl;
      setTimeout(() => {
        if (!document.hidden && Date.now() - start < 2000) {
          window.location.replace(PLAY_STORE_URL);
        }
      }, 1500);
      return;
    }

    // Desktop / other → Play Store.
    window.location.replace(PLAY_STORE_URL);
  }, [location]);

  return (
    <div
      style={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '18px',
        textAlign: 'center',
        padding: '24px',
        direction: 'rtl',
      }}
    >
      <h2 style={{ margin: 0 }}>🎬 جارِ فتح المحتوى…</h2>
      <p style={{ opacity: 0.75, margin: 0 }}>
        إذا لم يفتح التطبيق تلقائياً، اضغط الزر بالأسفل لتحميله.
      </p>
      <a
        href={PLAY_STORE_URL}
        style={{
          marginTop: 8,
          padding: '12px 22px',
          borderRadius: 12,
          background: '#F59E0B',
          color: '#000',
          fontWeight: 800,
          textDecoration: 'none',
        }}
      >
        تحميل التطبيق من Google Play
      </a>
    </div>
  );
}